// Shared by every country <select> across Elakay's Address/Telephone modals
// (AddressUser.jsx, addTelephone.jsx, userAddingRoleByToken's pageEditForm.jsx)
// so the flag-derivation logic exists in exactly one place. Derives a flag
// emoji from a 2-letter ISO 3166-1 alpha-2 code via the standard regional
// indicator symbol trick -- no image assets, no extra dependency (the same
// technique react-phone-number-input's own "country-flag-icons" package
// uses internally for its `unicodeFlags` option).
export const countryFlagEmoji = (code) => {
  if (!code || code.length !== 2) return "";
  return String.fromCodePoint(...[...code.toUpperCase()].map((c) => 127397 + c.charCodeAt(0)));
};
